import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2fcec1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content my-modal box" }
const _hoisted_2 = {
  key: 0,
  class: "tag is-danger",
  style: {"position":"absolute","top":"10px","left":"10px"}
}
const _hoisted_3 = { class: "highlight pt-5" }
const _hoisted_4 = { class: "post_content" }
const _hoisted_5 = { class: "title pt-1 mb-2 has-text-white" }
const _hoisted_6 = { class: "p-1 mb-2 has-text-white" }
const _hoisted_7 = { class: "is-size-7 pt-1 px-1 has-text-white" }
const _hoisted_8 = { class: "is-clickable" }
const _hoisted_9 = { class: "columns is-mobile controls m-0 is-size-5" }
const _hoisted_10 = { class: "column" }
const _hoisted_11 = { class: "column" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-comments" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "is-size-7 has-text-white has-text-weight-bold comment_notification"
}
const _hoisted_14 = {
  key: 1,
  class: "is-size-7 has-text-weight-bold comment_notification"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "99+", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "column" }

export function render(_ctx: any,_cache: any) {
  const _component_ExpandedPost = _resolveComponent("ExpandedPost")!
  const _component_LockIndicator = _resolveComponent("LockIndicator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.expanded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["modal", { 'is-active': _ctx.expanded }])
        }, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.collapse && _ctx.collapse(...args))),
            class: "modal-background"
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ExpandedPost, {
              slot: _ctx.slot,
              static_post: _ctx.static_post,
              openTo: _ctx.modalSelection
            }, null, 8, ["slot", "static_post", "openTo"])
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.collapse && _ctx.collapse(...args))),
            class: "modal-close is-large",
            "aria-label": "close"
          })
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "m-1",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.expand('comment')))
    }, [
      _createElementVNode("div", {
        class: "box pt-0 p-0",
        style: _normalizeStyle(' overflow:hidden; position:relative; background:url(' + _ctx.post.media + '); background-size:cover; background-repeat:no-repeat; background-position: center center; ')
      }, [
        (_ctx.isNew)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " NEW "))
          : _createCommentVNode("", true),
        (_ctx.post_status == 'locked')
          ? (_openBlock(), _createBlock(_component_LockIndicator, {
              key: 1,
              exp: _ctx.lock_expiration,
              style: {"position":"absolute","top":"10px","right":"10px"}
            }, null, 8, ["exp"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.post.title), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.post.content), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("b", _hoisted_8, _toDisplayString(_ctx.post.authorusername), 1),
            _createTextVNode(" - " + _toDisplayString(_ctx.postTime), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("i", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expand('like'))),
              class: "is-clickable far fa-heart"
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", {
              class: "icon is-clickable",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expand('comment'))),
              style: {"position":"relative"}
            }, [
              _hoisted_12,
              (_ctx.post.commentcount>0 && _ctx.post.commentcount<=99)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("u", null, _toDisplayString(_ctx.post.commentcount), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.post.commentcount>99)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("i", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expand('edit'))),
              class: "is-clickable fas fa-pen"
            })
          ])
        ])
      ], 4)
    ])
  ], 64))
}